"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
export const initialState = {
  candidate: null,
  errors: {},
  preferredName: "",
  gender: null,
  dateOfBirth: null,
  dateError: "",
  personalEmail: false,
  personalPhone: false,
  title: null,
  emergencyContact: {
    name: "",
    relationship: "",
    phone: "",
    email: ""
  },
  attachments: [],
  personCustomFieldAnswers: {},
  jobCustomFieldAnswers: {},
  jobStartDate: null,
  jobEndDate: null,
  jobStartDateError: "",
  jobEndDateError: "",
  probationEndDate: null,
  probationEndDateError: "",
  positionTitle: null,
  businessEntity: null,
  businessUnit: null,
  location: null,
  supervisor: null,
  employmentCondition: null,
  payGrade: null,
  workClass: null,
  fte: "",
  payCycle: null,
  hoursPerCycle: "",
  additionToBase: [],
  additionToTotal: [],
  breakdowns: [],
  currency: { code: "AUD", name: "Australian Dollar", symbol: "$" },
  salary: "",
  hasEndDate: false,
  sameAsCompanyStartDate: false,
  noSupervisor: false,
  noFTE: false,
  renumerationScheduleType: "Annual Salary",
  probationIsNotApplicable: false,
  useDefaultProbationLength: false
};
export function intelliHRReducer(state, action) {
  switch (action.type) {
    case "SET_CANDIDATE":
      return __spreadProps(__spreadValues({}, state), { candidate: action.payload });
    case "SET_ERRORS":
      return __spreadProps(__spreadValues({}, state), { errors: action.payload });
    case "SET_PREFERRED_NAME":
      return __spreadProps(__spreadValues({}, state), { preferredName: action.payload });
    case "SET_GENDER":
      return __spreadProps(__spreadValues({}, state), { gender: action.payload });
    case "SET_DATE_OF_BIRTH":
      return __spreadProps(__spreadValues({}, state), { dateOfBirth: action.payload });
    case "SET_DATE_ERROR":
      return __spreadProps(__spreadValues({}, state), { dateError: action.payload });
    case "SET_PERSONAL_EMAIL":
      return __spreadProps(__spreadValues({}, state), { personalEmail: action.payload });
    case "SET_PERSONAL_PHONE":
      return __spreadProps(__spreadValues({}, state), { personalPhone: action.payload });
    case "SET_TITLE":
      return __spreadProps(__spreadValues({}, state), { title: action.payload });
    case "SET_EMERGENCY_CONTACT":
      return __spreadProps(__spreadValues({}, state), { emergencyContact: __spreadValues(__spreadValues({}, state.emergencyContact), action.payload) });
    case "SET_ATTACHMENTS":
      return __spreadProps(__spreadValues({}, state), { attachments: action.payload });
    case "SET_PERSON_CUSTOM_FIELD_ANSWER":
      return __spreadProps(__spreadValues({}, state), {
        personCustomFieldAnswers: __spreadProps(__spreadValues({}, state.personCustomFieldAnswers), {
          [action.payload.id]: { value: action.payload.answer, type: action.payload.type }
        })
      });
    case "SET_JOB_CUSTOM_FIELD_ANSWER":
      return __spreadProps(__spreadValues({}, state), {
        jobCustomFieldAnswers: __spreadProps(__spreadValues({}, state.jobCustomFieldAnswers), {
          [action.payload.id]: { value: action.payload.answer, type: action.payload.type }
        })
      });
    case "SET_COMPANY_START_DATE":
      return __spreadProps(__spreadValues({}, state), { jobStartDate: action.payload });
    case "SET_COMPANY_END_DATE":
      return __spreadProps(__spreadValues({}, state), { jobEndDate: action.payload });
    case "SET_COMPANY_START_DATE_ERROR":
      return __spreadProps(__spreadValues({}, state), { jobStartDateError: action.payload });
    case "SET_COMPANY_END_DATE_ERROR":
      return __spreadProps(__spreadValues({}, state), { jobEndDateError: action.payload });
    case "SET_PROBATION_END_DATE":
      return __spreadProps(__spreadValues({}, state), { probationEndDate: action.payload });
    case "SET_PROBATION_END_DATE_ERROR":
      return __spreadProps(__spreadValues({}, state), { probationEndDateError: action.payload });
    case "SET_POSITION_TITLE":
      return __spreadProps(__spreadValues({}, state), { positionTitle: action.payload });
    case "SET_BUSINESS_ENTITY":
      return __spreadProps(__spreadValues({}, state), { businessEntity: action.payload });
    case "SET_BUSINESS_UNIT":
      return __spreadProps(__spreadValues({}, state), { businessUnit: action.payload });
    case "SET_LOCATION":
      return __spreadProps(__spreadValues({}, state), { location: action.payload });
    case "SET_SUPERVISOR":
      return __spreadProps(__spreadValues({}, state), { supervisor: action.payload });
    case "SET_EMPLOYMENT_CONDITION":
      return __spreadProps(__spreadValues({}, state), { employmentCondition: action.payload });
    case "SET_PAY_GRADE":
      return __spreadProps(__spreadValues({}, state), { payGrade: action.payload });
    case "SET_WORK_CLASS":
      return __spreadProps(__spreadValues({}, state), { workClass: action.payload });
    case "SET_FTE":
      return __spreadProps(__spreadValues({}, state), { fte: action.payload });
    case "SET_PAY_CYCLE":
      return __spreadProps(__spreadValues({}, state), { payCycle: action.payload });
    case "SET_HOURS_PER_CYCLE":
      return __spreadProps(__spreadValues({}, state), { hoursPerCycle: action.payload });
    case "SET_ADDITION_TO_BASE":
      return __spreadProps(__spreadValues({}, state), { additionToBase: action.payload });
    case "SET_ADDITION_TO_TOTAL":
      return __spreadProps(__spreadValues({}, state), { additionToTotal: action.payload });
    case "SET_BREAKDOWNS":
      return __spreadProps(__spreadValues({}, state), { breakdowns: action.payload });
    case "SET_CURRENCY":
      return __spreadProps(__spreadValues({}, state), { currency: action.payload });
    case "SET_SALARY":
      return __spreadProps(__spreadValues({}, state), { salary: action.payload });
    case "SET_HAS_END_DATE":
      return __spreadProps(__spreadValues({}, state), { hasEndDate: action.payload });
    case "SET_SAME_AS_COMPANY_START_DATE":
      return __spreadProps(__spreadValues({}, state), { sameAsCompanyStartDate: action.payload });
    case "SET_NO_SUPERVISOR":
      return __spreadProps(__spreadValues({}, state), { noSupervisor: action.payload });
    case "SET_NO_FTE":
      return __spreadProps(__spreadValues({}, state), { noFTE: action.payload });
    case "SET_RENUMERATION_SCHEDULE_TYPE":
      return __spreadProps(__spreadValues({}, state), { renumerationScheduleType: action.payload });
    case "SET_PROBATION_IS_NOT_APPLICABLE":
      return __spreadProps(__spreadValues({}, state), { probationIsNotApplicable: action.payload });
    case "SET_USE_DEFAULT_PROBATION_LENGTH":
      return __spreadProps(__spreadValues({}, state), { useDefaultProbationLength: action.payload });
    default:
      return state;
  }
}
